import {runPendingDesignReveal} from '@Components/poster-editor/library/pending-design-reveal.library';
import type {PendingDesignPollOutcome} from '@Components/poster-editor/library/pending-design-reveal.library.types';
import {PendingDesignPollStatus} from '@Components/poster-editor/library/pending-design-reveal.library.types';
import {getMdeLoadingTexts, getMdePosterUrl, MDE_POLL_BUDGET_MS, pollMdeJob} from '@Libraries/make-design-editable.library';
import {showMdeFeedbackToast} from '@Libraries/make-design-editable-feedback.library';
import type {MdePendingFlowOptions} from '@Libraries/make-design-editable-editor.library.types';

/** Editor-tab half of the desktop "Editable image" flow, triggered through the poster-ui port. */
export const runMdePendingFlow = (jobId: string, {originalImageUrl}: MdePendingFlowOptions): Promise<void> => {
  return runPendingDesignReveal({
    jobId,
    originalImageUrl,
    loadingCopy: {title: window.i18next.t('pmwjs_mde_extracting_design_layers'), texts: getMdeLoadingTexts()},
    readyGrowlText: window.i18next.t('pmwjs_mde_design_ready'),
    failureGrowlText: window.i18next.t('pmwjs_mde_failed'),
    pollJob: pollMdeJobForReveal,
    showFeedback: (): void => {
      showMdeFeedbackToast(jobId);
    },
    getPosterUrlWithFeedback: (posterHashedId: string): string => {
      return getMdePosterUrl({jobId, posterHashedId});
    },
  });
};

const pollMdeJobForReveal = async (jobId: string): Promise<PendingDesignPollOutcome> => {
  const outcome = await pollMdeJob(jobId, MDE_POLL_BUDGET_MS);
  if (outcome === null) {
    return {status: PendingDesignPollStatus.TIMED_OUT};
  }
  return {status: PendingDesignPollStatus.READY, posterHashedId: outcome.posterHashedId};
};
